import { Box, Typography } from "@mui/material";
import React from 'react'

function TabPanel(props:any) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`vertical-tabpanel-${index}`} aria-labelledby={`vertical-tab-${index}`} {...other}>
      {value === index && (
        <Box
          p={3}
          sx={{
            paddingTop: "0px",
            marginTop: "0px"
          }}
        >
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export default TabPanel;
